"use client";
import React, { useState, useEffect } from "react";
import Icon from "../icons/Icons";
import { useDispatch } from "react-redux";
import { openHelpModal } from "@/redux/features/HelpModal/helpModalSlice";

export default function NeedHelpButton() {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      <button onClick={() => dispatch(openHelpModal())} aria-label="Help Button" className={`${isVisible ? "bottom-36.25" : "bottom-18.75"} fixed opacity-100 right-4 w-11.5 h-11.5 sm:w-12 sm:h-12 rounded-full transition-all duration-300 z-150`}>
        <Icon.supportIconV1 className="w-11.5 h-11.5 sm:w-12 sm:h-12 shadow-[0_4px_4px_0_#1A51AA20] rounded-full text-(--text)" />
      </button>
    </>
  );
}
